// extracted by mini-css-extract-plugin
module.exports = {"pc_only":"Select__pc_only___1iBsd","sp_only":"Select__sp_only___2e9uM","select":"Select__select___1aMof"};